import { useCallback, useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { useConfirmationModal } from 'shared/components/ConfirmationModal';
import { REPRESENTATIVES_QUERY_STRING } from 'shared/constants/REPRESENTATIVES_QUERY_STRING';
import { ROUTES } from 'shared/constants/ROUTES';
import { representativeService } from 'shared/services/representativesService';

const { deleteRepresentative } = representativeService();

export const useEditProfileDelete = (
  profileId: string,
  isPrimary: boolean,
  errorCallback: (title: string, message: string) => void,
) => {
  const { ConfirmationModal, handleOpen, isOpen } = useConfirmationModal({
    type: 'warning',
    title: 'Delete Representative',
    message: 'This will delete your representative. This action is irreversible. Are you sure you want to proceed?',
  });
  const history = useHistory();
  const queryClient = useQueryClient();
  const { mutate: deleteRepresentativeMutate, isLoading: isDeleting } = deleteRepresentative();

  const handleDeleteConfirmation = useCallback(() => {
    if (isPrimary) {
      errorCallback('Delete Representative', 'You are not allowed to delete your primary representative');
    } else {
      handleOpen();
    }
  }, []);

  const handleDeleteRepresentative = useCallback(() => {
    deleteRepresentativeMutate(profileId, {
      onSuccess: async () => {
        await queryClient.invalidateQueries([REPRESENTATIVES_QUERY_STRING.representatives_multiple_profile], {
          refetchInactive: true,
        });
        history.push(ROUTES.TALENT.REPRESENTATIVES);
      },
      onError: () => {
        errorCallback('Something went wrong', 'Cannot delete your profile at the moment');
      },
    });
  }, [profileId]);

  return { isDeleting, handleDeleteRepresentative, ConfirmationModal, handleDeleteConfirmation, isOpen };
};
